var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isDevEnv
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "16px" } },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "outline-primary",
                    disabled: _vm.disabledFields
                  },
                  on: { click: _vm.fillTestData }
                },
                [_vm._v("Preencher dados de teste")]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "A) " + _vm.$t("coup_attempt_type"),
            "label-for": "incidentCoupAttemptTypeListSelected"
          }
        },
        [
          _c("validation-provider", {
            attrs: { name: _vm.$t("coup_attempt_type"), rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-checkbox-group", {
                      attrs: {
                        options: _vm.coupAttemptTypeList,
                        "value-field": "id",
                        "text-field": "name",
                        name: "incidentCoupAttemptTypeListSelected",
                        disabled: _vm.disabledFields,
                        stacked: ""
                      },
                      model: {
                        value: _vm.incidentCoupAttemptTypeListSelected,
                        callback: function($$v) {
                          _vm.incidentCoupAttemptTypeListSelected = $$v
                        },
                        expression: "incidentCoupAttemptTypeListSelected"
                      }
                    }),
                    _vm.enableCoupAttemptTypeOther
                      ? _c("b-form-input", {
                          staticClass: "mt-1",
                          attrs: {
                            id: "otherCoupAttempt",
                            state: errors.length > 0 ? false : null,
                            name: "coupAttemptOther",
                            disabled: _vm.disabledFields
                          },
                          model: {
                            value: _vm.otherCoupAttempt,
                            callback: function($$v) {
                              _vm.otherCoupAttempt = $$v
                            },
                            expression: "otherCoupAttempt"
                          }
                        })
                      : _vm._e(),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("incident_form_responsible_email"),
            "label-for": "incident_form_responsible_email"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_responsible_email"),
              rules: "required|email"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_responsible_email",
                        state: errors.length > 0 ? false : null,
                        name: "responsibleEmail",
                        disabled: _vm.disabledFields,
                        type: "email"
                      },
                      model: {
                        value: _vm.responsibleEmail,
                        callback: function($$v) {
                          _vm.responsibleEmail = $$v
                        },
                        expression: "responsibleEmail"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "C) " + _vm.$t("incident_form_date_coup_attempt"),
            "label-for": "incident_date"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_date_coup_attempt"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("flat-pickr", {
                      staticClass: "form-control required",
                      class: { "is-disabled": _vm.disabledFields },
                      attrs: {
                        config: _vm.configCalendar,
                        disabled: _vm.disabledFields
                      },
                      model: {
                        value: _vm.incidentDate,
                        callback: function($$v) {
                          _vm.incidentDate = $$v
                        },
                        expression: "incidentDate"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "D) " + _vm.$t("incident_form_unit"),
            "label-for": "unity"
          }
        },
        [
          _c("validation-provider", {
            attrs: { name: _vm.$t("incident_form_unit"), rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "v-select",
                      {
                        staticClass: "required-select",
                        attrs: {
                          options: _vm.listLegal,
                          label: "name",
                          disabled: _vm.disabledFields
                        },
                        model: {
                          value: _vm.legalEntity,
                          callback: function($$v) {
                            _vm.legalEntity = $$v
                          },
                          expression: "legalEntity"
                        }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [_vm._v(_vm._s(_vm.$t("msg_none")))]
                        )
                      ]
                    ),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "E) " + _vm.$t("incident_form_description_coup_attempt"),
            "label-for": "incident_form_description_coup_attempt"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_description_coup_attempt"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      attrs: {
                        id: "incident_form_description_coup_attempt",
                        state: errors.length > 0 ? false : null,
                        placeholder: _vm.$t("incident_form_min_caracter"),
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.descriptionIncident,
                        callback: function($$v) {
                          _vm.descriptionIncident = $$v
                        },
                        expression: "descriptionIncident"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "F) " +
              _vm.$t("incident_form_who_reported_coup_attempt") +
              _vm.$t("incident_form_name_tel_email"),
            "label-for": "incident_form_who_reported"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_who_reported_coup_attempt"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_who_reported_coup_attempt",
                        state: errors.length > 0 ? false : null,
                        placeholder: _vm.$t("incident_form_min_caracter"),
                        name: "whoReported",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.whoReported,
                        callback: function($$v) {
                          _vm.whoReported = $$v
                        },
                        expression: "whoReported"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "G) " +
              _vm.$t("incident_form_responsible_unit") +
              _vm.$t("incident_form_name_tel_email"),
            "label-for": "incident_form_responsible_unit"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_responsible_unit"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_responsible_unit",
                        state: errors.length > 0 ? false : null,
                        name: "responsibleUnit",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.responsibleUnit,
                        callback: function($$v) {
                          _vm.responsibleUnit = $$v
                        },
                        expression: "responsibleUnit"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "H) " + _vm.$t("incident_form_how_identified"),
            "label-for": "incident_form_how_identified"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_how_identified"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_how_identified",
                        state: errors.length > 0 ? false : null,
                        name: "howIdentified",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.howIdentified,
                        callback: function($$v) {
                          _vm.howIdentified = $$v
                        },
                        expression: "howIdentified"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }